// Statsig feature flags
export const FEATURE_FLAGS = {
  PORTAL_STAFFER_MODE_FOR_ORG: 'portal_staffer_mode_for_org',
  DOCUMENT_MARKUP_BY_CASE: 'document_markup_by_case',
  CASES_MAP_STATUS_COLORS_FOR_ORG: 'cases_map_status_colors_for_org',
  ADD_AR_CODE_TO_CASE_FEED: 'add_ar_code_to_case_feed',
  LICENSES_AND_PERMITS: 'licenses_and_permits',
  BLOCK_DIRECT_ACCESS_SHARING: 'block_direct_access_sharing',
  DOCX_DOC_GEN: 'docx_doc_gen',
  CONTACT_STEP_WHO_ARE_YOU: 'contact_step_who_are_you',
  PUBLIC_RECORDS_STUDIO: 'public_records_studio',
  REDACTION_BLOCK: 'redaction_block',
  CLOSED_CASE_READ_ONLY: 'closed_case_read_only',
  SUMMARIZE_LONG_CASE_FEED_EMAILS: 'summarize_long_case_feed_emails',
  ENABLE_MANAGER_STAFF_VIEW: 'enable_manager_staff_view',
  AI_USAGE_POLICIES: 'ai_usage_policies',
  AI_SKILLS: 'ai_skills',
  CUSTOM_AI_INTERACTION_CATEGORIES: 'custom_ai_interaction_categories',
  AI_VOICE_ZDR: 'AI_Voice_ZDR',
  KNOWLEDGE_BASE_REDESIGN: 'knowledge_base_redesign',
  INTEGRATION_BLOCKS: 'Integration_Blocks',
  CITYWORKS_INTEGRATION_BLOCK: 'cityworks_integration_block',
  CENTRAL_SQUARE_INTEGRATION_BLOCK: 'central_square_integration_block',
  WORKFLOW_BUILDER: 'workflow_builder',
  ENABLE_AGENTIC_INTEGRATION_IMPLEMENTATION: 'enable_agentic_integration_implementation',
  REVIEW_BLOCKS: 'Review_Blocks',
  SHOW_TIER_PERSONA_SELECTORS: 'Show_tier_persona_selectors',
}
